<template>
  <div class="home" :class="{ 'fixed--over_nav' : viewSettings, 'fixed--under_nav' : searchActive }">
		
		<div class="action_bar">
				<button class="button--account" @click="viewSettings = true">{{ activeProvince }} <img src="/img/icon--account.svg" class="icon" alt="Settings"></button>
			</div>

		<main>
			<h2>Cut-off is in 2 days</h2>
			<h2>Claims saved by tomorrow will make the cut</h2>

			<div class="search" :class="{ active : searchActive, underneath : searchSubviewHasLaunched }">
				<input class="search_input" placeholder="Search for anything.." @focus="searchActive = true">
				<button class="search_input--clear" @click="searchActive = false">Close</button>
			</div>

			<div class="nav--home">
				<button :class="{ active : tabStatus }" @click="tabStatusActive()">Status</button>
				<button :class="{ active : tabActivity }" @click="tabActivityActive()">Activity <div class="activity--count">8</div></button>
				<!-- <button :class="{ active : tabHelp }" @click="tabHelpActive()">Help</button> -->
			</div>

			<div class="status" v-if="tabStatus">
				<div class="status--widget claims">
					<div class="status--widget--title">
						<h3>Claims status</h3>
						<div class="icon icon--help" @click="homeWidgetHelp()"></div>
					</div>
					<div class="claims_status">
						<div class="claims_status--cell">
							<div class="claims_status--cell--title">To submit</div>
							<div class="claims_status--cell--count claims_status--cell--dollars">2,348</div>
						</div>
						<div class="claims_status--cell">
							<div class="claims_status--cell--title">With MSP</div>
							<div class="claims_status--cell--count claims_status--cell--dollars">10,583</div>
						</div>
						<div class="claims_status--cell">
							<div class="claims_status--cell--title">In review</div>
							<div class="claims_status--cell--count claims_status--cell--dollars">1,833</div>
						</div>
					</div>
					<div class="claims_status--issues">
						<div class="claims_status--issues--title">5 issues need attention</div>
						<!-- <div class="claims_status--issues--count">4</div> -->
					</div>
				</div>

				<div class="status--widget payment_timeline">
					<div class="status--widget--title">
						<h3>Payment timeline</h3>
						<div class="icon icon--help" @click="homeWidgetHelp()"></div>
					</div>
					<div class="payment_timeline--timeline">
						<ul>
							<li>
								<div class="check checked"></div>
								<div class="check--title">
									<div class="check--title--date">15 Feb</div>
									<div class="check--title--event">Payment - <span>$11,968</span></div>
								</div>
							</li>
							<li>
								<div class="check checked"></div>
								<div class="check--title">
									<div class="check--title--date">15 Feb</div>
									<div class="check--title--event">Cut-off - <span>$8,478 submitted</span></div>
								</div>
							</li>
							<li>
								<div class="check"></div>
								<div class="check--title">
									<div class="check--title--date">26 Feb</div>
									<div class="check--title--event">Remittance</div>
								</div>
							</li>
							<li>
								<div class="check"></div>
								<div class="check--title">
									<div class="check--title--date">28 Feb</div>
									<div class="check--title--event">Payment</div>
								</div>
							</li>
							<!-- <li>
								<div class="check"></div>
								<div class="check--title">
									<div class="check--title--date">5 Mar</div>
									<div class="check--title--event">Cut-off</div>
								</div>
							</li> -->
						</ul>
					</div>
				</div>

				<div class="status--widget trends">
					<div class="status--widget--title">
						<h3>Trends</h3>
						<div class="icon icon--help" @click="homeWidgetHelp()"></div>
					</div>
					<div class="trends--chart">{{ trendsChartPeriod }}</div>
					<div class="trends--period_selector">
						<button class="period--1" @click="trendsChartPeriod = 'D'">D</button>
						<button class="period--2" @click="trendsChartPeriod = 'W'">W</button>
						<button class="period--3" @click="trendsChartPeriod = 'M'">M</button>
						<button class="period--4" @click="trendsChartPeriod = '3M'">3M</button>
					</div>
				</div>

				<div class="status--widget statistics">
					<div class="status--widget--title">
						<h3>Overall statistics</h3>
						<div class="icon icon--help" @click="homeWidgetHelp()"></div>
					</div>
					<div class="claims_status">
						<!-- <div class="claims_status--cell">
							<div class="claims_status--cell--count claims_status--cell--dollars">2.3k</div>
							<div class="claims_status--cell--title">Recovery in progress</div>
						</div> -->
						<div class="claims_status--cell">
							<div class="claims_status--cell--count claims_status--cell--dollars">22.8k</div>
							<div class="claims_status--cell--title">Amount recovered</div>
						</div>
						<div class="claims_status--cell">
							<div class="claims_status--cell--count claims_status--cell--percentage">93.7</div>
							<div class="claims_status--cell--title">Payout rate</div>
						</div>
					</div>
				</div>

				<!-- <button class="button-refresh" @click="refresh()">Refresh</button> -->
			</div>


			<div class="activity" v-if="tabActivity">
				<!-- <div class="sign_up">
					<div class="sign_up--header">
						Remittance received
						<div>15 Feb</div>
					</div>
				</div> -->
				
				<!-- <div class="remittance_update remittance_update--remittance_received">
					<div class="remittance_update--header">
						<div>Remittance has been received</div>
						<div class="icon icon--check--success"></div>
					</div>
					<div class="remittance_update--body">
						<p>$7,482 in claims have been submitted to MSP.</p>
					</div>
				</div> -->

				<div class="remittance_update remittance_update--issues">
					<div class="remittance_update--header">
						<div>Remittance received</div>
						<div style="color: #999">13 Feb</div>
					</div>
					<div class="remittance_update--body">
						<ul>
							<li><span>$7,936</span> will be paid on <span>15 Feb</span>.</li>
							<li><span>$943</span> of claims were not paid. Our agents will review and recover as much as possible.</li>
							<li><span>$266</span> of claims were refused and will be written off.</li>
						</ul>
					</div>
				</div>

				<div class="remittance_update remittance_update--issues">
					<div class="remittance_update--header">
						<div>5 issues need fixing</div>
						<div style="color: #999">13 Feb</div>
					</div>
					<div class="remittance_update--body">
						<p>Our agents are unable to fix the following claims without more information. Please review and resubmit.</p>
						<div class="remittance_update--cell" @click="patientIssueName = 'Konstantin Karpov', viewActivity1 = true">
							<h4>Konstantin Karpov</h4>
						</div>
						<div class="remittance_update--cell" @click="patientIssueName = 'Constance Wright', viewActivity1 = true">
							<h4>Constance Wright</h4>
						</div>
						<div class="remittance_update--cell" @click="patientIssueName = 'Lou Xiang', viewActivity1 = true">
							<h4>Lou Xiang</h4>
						</div>
						<div class="remittance_update--cell" @click="patientIssueName = 'Suzanna Harewood', viewActivity1 = true">
							<h4>Suzanna Harewood</h4>
						</div>
						<div class="remittance_update--cell" @click="patientIssueName = 'Suzanna Harewood', viewActivity1 = true">
							<h4>Suzanna Harewood</h4>
						</div>
					</div>
				</div>

				<div class="remittance_update remittance_update--rejections">
					<div class="remittance_update--header">
						<div>3 claims were rejected</div>
						<div style="color: #999">11 Feb</div>
					</div>
					<div class="remittance_update--body">
						<p>Our agents will review, fix, and resubmit where possible, but you can also review for faster resubmission.</p>
						<div class="remittance_update--cell" @click="patientIssueName = 'Rachel Smith', viewActivity1 = true">
							<h4>Rachel Smith</h4>
							<!-- <h4 class="date">14 Feb</h4> -->
						</div>
						<div class="remittance_update--cell" @click="patientIssueName = 'Craig McKenzie', viewActivity1 = true">
							<h4>Craig McKenzie</h4>
							<!-- <h4 class="date">14 Feb</h4> -->
						</div>
						<div class="remittance_update--cell" @click="patientIssueName = 'Ravichandaran Chandrasakar', viewActivity1 = true">
							<h4>Ravichandaran Chandrasakar</h4>
							<!-- <h4 class="date">14 Feb</h4> -->
						</div>
					</div>
				</div>

<!-- 
				<div class="alert" @click="viewActivity1 = true">
					<div class="alert--header">
						<div class="alert--header--date">19 Jan</div>
						<div class="alert--header--name">Konstantin Karpov</div>
					</div>
					<div class="alert--details">
						<div class="alert--details--status alert--details--status--open">
							Review required
						</div>
						<div class="alert--details--explanation">
							Fee item requires pre-authorization. Please resubmit with the operative/procedural report and provide details regarding the medical necessity.
						</div>
					</div>
				</div>

				<div class="alert" @click="viewActivity1 = true">
					<div class="alert--header">
						<div class="alert--header--date">19 Jan</div>
						<div class="alert--header--name">Lou Peng</div>
						<div class="alert--header--code">18873</div>
					</div>
					<div class="alert--details">
						<div class="alert--details--status alert--details--status--pending">
							Claim on hold
						</div>
						<div class="alert--details--explanation">
							Claim has been paid/refused pending review by our Medical Advisors. You will be notified of any changes.
						</div>
					</div>
				</div>

				<div class="alert" @click="viewActivity1 = true">
					<div class="alert--header">
						<div class="alert--header--date">19 Jan</div>
						<div class="alert--header--name">Richard White-Spencer</div>
						<div class="alert--header--code">13008</div>
						<div class="alert--header--code">13338</div>
					</div>
					<div class="alert--details">
						<div class="alert--details--status alert--details--status--open">
							Review required
						</div>
						<div class="alert--details--explanation">
							Long-term care institution visits have been paid during the time you are billing for home visits. Please verify location of service.
						</div>
					</div>
				</div>

				<div class="alert" @click="viewActivity1 = true">
					<div class="alert--header">
						<div class="alert--header--date">19 Jan</div>
						<div class="alert--header--name">Julie Donahue</div>
						<div class="alert--header--code">00063</div>
					</div>
					<div class="alert--details">
						<div class="alert--details--status alert--details--status--open">
							Review required
						</div>
						<div class="alert--details--explanation">
							This service is the responsibility of WorkSafeBC. Please resubmit with "WC" insurer code.
						</div>
					</div>
				</div>

				<div class="alert" @click="viewActivity1 = true">
					<div class="alert--header">
						<div class="alert--header--date">19 Jan</div>
						<div class="alert--header--name">Kristin Smith</div>
						<div class="alert--header--code">10082</div>
					</div>
					<div class="alert--details">
						<div class="alert--details--status alert--details--status--open">
							Review required
						</div>
						<div class="alert--details--explanation">
							Details required for frequency of servicing. Please resubmit with explanation in note record.
						</div>
					</div>
				</div>
 -->
				<div class="sign_up">
					<div class="sign_up--header">
						OHIP set up progress
					</div>
					<div class="sign_up--details in_progress">
						<ul>
							<li>
								<div class="check checked"></div>
								<div class="check--title">Create Dr. Bill account</div>
							</li>
							<li>
								<div class="check checked"></div>
								<div class="check--title">Submit "Authority to Bill" to OHIP</div>
							</li>
							<li>
								<div class="check checked"></div>
								<div class="check--title">Connect Go Secure to Dr. Bill</div>
							</li>
							<li>
								<div class="check"></div>
								<div class="check--title">Go Secure confirms connection</div>
							</li>
							<li>
								<div class="check flag"></div>
								<div class="check--title">Finished!</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="sign_up">
					<div class="sign_up--header">
						MSP set up progress
					</div>
					<div class="sign_up--details complete">
						<div class="check flag"></div>
						<p>You're all set to be paid by MSP!</p>
					</div>
				</div>
			</div>
			<div class="activity" v-if="tabHelp">
				xcvbnm
			</div>

			<transition name="search_results_fade">
				<div class="search_results" :class="{ underneath : searchSubviewHasLaunched }" v-show="searchActive">
					<div class="group">

						<transition name="previous_search_list_fade">
						<ul class="previous_search_list" v-show="searchActive">
							<li>
								<button @click="patientActive = true, searchSubviewHasLaunched = true">Madonna Abernathy</button>
								<button class="button--search_options" @click="showActionSheet(), $store.commit('navBarMinimised', true)"></button>
							</li>
							<li>
								<button @click="codeActive = true, searchSubviewHasLaunched = true">
									<div class="code">01096</div> Retrobulbar / Peribulbar block with abergail anaesthesia
								</button>
							</li>
							<li>
								<button @click="articleActive = true, searchSubviewHasLaunched = true">MSP Billing Guide for General Internal Medicine</button>
							</li>
						</ul>
						</transition>

					</div>
				</div>
			</transition>
    </main>


    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1200" v-if="articleActive">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="articleActive = false, searchSubviewHasLaunched = false"></button>
				</div>

				<div class="modalView--container">
					<h1 v-html="HelpStore.help[1].title"></h1>
					<div v-html="HelpStore.help[1].body"></div>
				</div>
			</ModalView>
    </transition>
		
		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1200" v-if="codeActive">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="codeActive = false, searchSubviewHasLaunched = false"></button>
				</div>

				<div class="modalView--container">
					<h1>01096<br><span>Retrobulbar / Peribulbar block with abergail anaesthesia</span></h1>
					<p>This billing code is a fixed fee which is paid in addition to the anesthetic procedural fee. It's not included in the anesthetic procedural fee for the application of 01080.</p>

					<ul style="margin-top: 2rem">
						<li><button style="color: var(--blue); font-size: 17px">Create template with code</button></li>
						<li><button style="color: var(--blue); font-size: 17px">Add code to claim</button></li>
					</ul>
				</div>
			</ModalView>
    </transition>


    <transition name="modalView_pushLeft">
			<ModalView class="patient_card" :modalZIndex="1200" v-if="patientActive">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="patientActive = false, actionMenu = false, searchSubviewHasLaunched = false"></button>
					<button class="action_menu" :class="{active : actionMenu}">
						<div class="action_menu--title" @click="actionMenu = !actionMenu">Actions</div>
						<div class="action_menu--curve" v-if="actionMenu"></div>
						<div class="action_menu--dropdown" v-if="actionMenu">
							<ul>
								<li><button>Edit groups</button></li>
								<li class="action_menu--dropdown--border"><button>Edit profile</button></li>
								<li class="action_menu--dropdown--border"><button>Share patient profile</button></li>
								<li><button style="color: red">Archive</button></li>
							</ul>
						</div>
					</button>
				</div>
				<div class="modalView--container">
					<h1>Madonna Abernathy</h1>
					<!-- <h4>BC: 8890-743-443</h4> -->
					<ul class="patient--data">
						<li class="patient--groups">
							<div class="patient--data--group">
								<!-- <div class="patient--data--group">Groups</div> -->
								<div>
									<div class="patient--groups--cell" @click="viewGroup1 = true">Methadone</div>
									<div class="patient--groups--cell" @click="viewGroup2 = true">Ward 7 Red</div>
								</div>
							</div>
						</li>
						<!-- <li class="patient--province">
							<div class="patient--data--group">
								<div class="patient--data--group">Province</div>
								<div>BC</div>
							</div>
							<div class="patient--data--group">
								<div class="patient--data--group">PHN</div>
								<div>8890-743-443</div>
							</div>
						</li> -->
						
					</ul>
					<div class="nav--claim">
						<button :class="{ active : patientTab1Active }" @click="patientTab1Active = true, patientTab2Active = false">Claims</button>
						<button :class="{ active : patientTab2Active }" @click="patientTab1Active = false, patientTab2Active = true">Profile</button>
					</div>
					<div class="patient_tab--1" v-if="patientTab1Active">
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
						<p>Claim</p>
					</div>
					<div class="patient_tab--2" v-if="patientTab2Active">
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
						<p>Profile</p>
					</div>
					<div class="patient--action_bar">
						<div><button class="primary">Start new claim</button></div>
						<div><button class="primary">Apply template</button></div>
					</div>
				</div>
			</ModalView>
    </transition>


    <!-- Start of modalSlideUp -->
    <ModalSlideUp :showComponents="actionSheetActive" @updateStatus="actionSheetActive = false">
			<ul class="slide_up--actions">
				<li><button>Add to workspace</button></li>
				<li><button>Apply template</button></li>
			</ul>
    </ModalSlideUp>
    <!-- End of modalSlideUp -->


		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewChangeEmail">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewChangeEmail = false, firstSubviewHasLaunched = false"></button>
				</div>

				<div class="modalView--container">
					<h1>Change email</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewChangePassword">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewChangePassword = false, firstSubviewHasLaunched = false"></button>
				</div>

				<div class="modalView--container">
					<h1>Change password</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewSecurityPin">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewSecurityPin = false, firstSubviewHasLaunched = false"></button>
				</div>

				<div class="modalView--container">
					<h1>Unlock with PIN</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewFingerprint">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewFingerprint = false, firstSubviewHasLaunched = false"></button>
				</div>

				<div class="modalView--container">
					<h1>Unlock with fingerprint</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewAlberta">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewAlberta = false, firstSubviewHasLaunched = false"></button>
				</div>
				<div class="modalView--container">
					<h1>Alberta</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewBritishColumbia">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewBritishColumbia = false, firstSubviewHasLaunched = false"></button>
				</div>
				<div class="modalView--container">
					<h1>British Columbia</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewOntario">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewOntario = false, firstSubviewHasLaunched = false"></button>
				</div>
				<div class="modalView--container">
					<h1>Ontario</h1>
				</div>
			</ModalView>
		</transition>


		<transition name="modalView_slide">
			<ModalView class="subview" :class="{ underneath : firstSubviewHasLaunched }" v-if="viewSettings">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--close" @click="viewSettings = false"></button>
				</div>
				<div class="modalView--container">
					<h1>Settings</h1>
					<ul>
						<li>Active province 
							<div class="segmented_controller">
								<button class="button--controller" :class="{ active : activeProvince == 'AB' }" @click="activeProvince = 'AB'">AB</button>
								<button class="button--controller" :class="{ active : activeProvince == 'BC' }" @click="activeProvince = 'BC'">BC</button>
								<button class="button--controller" :class="{ active : activeProvince == 'ON' }" @click="activeProvince = 'ON'">ON</button>
							</div>
						</li>
					</ul>

					<div class="group">
						<h5>Provincial configuration</h5>
						<ul>
							<li><button class="list_item" @click="viewAlberta = true, firstSubviewHasLaunched = true">Alberta</button></li>
							<li><button class="list_item" @click="viewBritishColumbia = true, firstSubviewHasLaunched = true">British Columbia</button></li>
							<li><button class="list_item" @click="viewOntario = true, firstSubviewHasLaunched = true">Ontario</button></li>
						</ul>
					</div>

					<div class="group">
						<h5>Account</h5>
						<ul>
							<li class="major">
								<button class="list_item list_item--with_minor_text" @click="viewChangeEmail = true, firstSubviewHasLaunched = true">
									Change email <div class="minor">janine.southby@vancouvermedico.ca</div>
								</button>
							</li>
							<li>
								<button class="list_item" @click="viewChangePassword = true, firstSubviewHasLaunched = true">
									Change password
								</button>
							</li>
							<li class="list_item--security_pin">
								<button class="list_item" @click="viewSecurityPin = true, firstSubviewHasLaunched = true">
									Unlock with PIN
								</button>
								<ElementSwitch></ElementSwitch>
							</li>
							<li class="list_item--security_pin">
								<button class="list_item" @click="viewFingerprint = true, firstSubviewHasLaunched = true">
									Unlock with fingerprint
								</button>
								<ElementSwitch></ElementSwitch>
							</li>
						</ul>
					</div>

					<div class="group">
						<h5>About</h5>
						<ul>
							<li>
								<button class="list_item">
									Diagnostics
								</button>
							</li>
							
						</ul>
					</div>
				</div>

			</ModalView>
		</transition>


		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewActivity1">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewActivity1 = false"></button>
				</div>

				<div class="modalView--container">
					<h1>{{ patientIssueName }}</h1>
					<p>Solve any issue here.</p>
				</div>
			</ModalView>
		</transition>


		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1210" v-if="viewGroup1">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewGroup1 = false"></button>
					<button class="action_bar-text_action">Edit</button>
				</div>

				<div class="modalView--container">
					<h1>Methadone</h1>
					<ul>
						<li>Rocky Filice</li>
						<li>Noma Lamantia</li>
						<li>Josette Mauldin</li>
						<li>Darwin Schrum</li>
						<li>Calista Lindow</li>
						<li>Simona Cousin</li>
						<li>Grazyna Kelson</li>
						<li>Liz Espinal</li>
						<li>Clarinda Brock</li>
						<li>Jacqualine Johansson</li>
						<li>Sanjuanita Canton</li>
						<li>Tonisha Rohlfing</li>
						<li>Louetta Westbrooks</li>
						<li>Lavern Marcinko</li>
						<li>Linn Oller</li>
						<li>Luella Nee</li>
						<li>Kasandra Hofstetter</li>
						<li>Onie Lassen</li>
						<li>Treva Heyer</li>
						<li>Olen Kua</li>
					</ul>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1210" v-if="viewGroup2">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewGroup2 = false"></button>
					<button class="action_bar-text_action">Edit</button>
				</div>

				<div class="modalView--container">
					<h1>Ward 7 Red</h1>
					<ul>
						<li>Rocky Filice</li>
						<li>Noma Lamantia</li>
						<li>Josette Mauldin</li>
						<li>Darwin Schrum</li>
						<li>Calista Lindow</li>
						<li>Simona Cousin</li>
						<li>Grazyna Kelson</li>
						<li>Liz Espinal</li>
						<li>Clarinda Brock</li>
						<li>Jacqualine Johansson</li>
						<li>Sanjuanita Canton</li>
						<li>Tonisha Rohlfing</li>
						<li>Louetta Westbrooks</li>
						<li>Lavern Marcinko</li>
						<li>Linn Oller</li>
						<li>Luella Nee</li>
						<li>Kasandra Hofstetter</li>
						<li>Onie Lassen</li>
						<li>Treva Heyer</li>
						<li>Olen Kua</li>
					</ul>
				</div>
			</ModalView>
		</transition>

  </div>
</template>

<script>
import ModalView from '@/components/ModalView.vue'
import ModalSlideUp from '@/components/ModalSlideUp.vue'
import ElementSwitch from '@/components/ElementSwitch.vue'
import HelpStore from '@/stores/HelpStore.js'

export default {
  name: 'home',
  components: {
    ModalView,
    ModalSlideUp,
    ElementSwitch,
  },
  data: function () {
    return {
			trendsChartPeriod: 'D',
			patientIssueName: 'Konstantin Karpov',
			searchActive: false, 
			tabStatus: true,
			tabActivity: false,
			tabHelp: false,
			firstSubviewHasLaunched: false,
			viewHasLaunched: false,
			viewAlberta: false,
			viewBritishColumbia: false,
			viewOntario: false,
			viewSettings: false,
			viewChangeEmail: false,
			viewChangePassword: false,
			viewSecurityPin: false,
			viewFingerprint: false,
			activeProvince: 'BC',
			touchIdActive: false,
			HelpStore: HelpStore.data,
			searchSubviewHasLaunched: false,
			articleActive: false,
			codeActive: false,
			patientActive: false,
			actionSheetActive: false,
			actionMenu: false,
			viewActivity1: false,
			patientTab1Active: true,
			patientTab2Active: false,
			viewGroup1: false,
			viewGroup2: false,
    }
  },
  methods: {
		tabStatusActive() {
			if ( this.tabStatus == false) {
				this.tabStatus = true;
				this.tabActivity = false;
				this.tabHelp = false;
			}
		},
		tabActivityActive() {
			if ( this.tabActivity == false) {
				this.tabStatus = false;
				this.tabActivity = true;
				this.tabHelp = false;
			}
		},
		tabHelpActive() {
			if ( this.tabHelp == false) {
				this.tabActivity = false;
				this.tabStatus = false;
				this.tabHelp = true;
			}
		},
		homeWidgetHelp() {
			alert('Show help text to explain this widget');
		},
		showActionSheet() {
			this.actionSheetActive = true;
		},
		refresh() {
			if ( confirm("Refresh?") ) {
				window.location.reload();
			}
		},
  }
}
</script>


<style scoped>
.home {
	-webkit-overflow-scrolling: touch;
	bottom: env(safe-area-inset-bottom);
	left: 0;
	overflow-x: hidden;
	overflow-y: scroll;
	position: fixed;
	right: 0;
	top: env(safe-area-inset-top);
}

.fixed--under_nav {
	overflow: hidden;
	position: fixed;
	/*top: 0;*/
	top: env(safe-area-inset-top);
	z-index: 990;
}
.fixed--over_nav {
	position: fixed;
	top: env(safe-area-inset-top);
	z-index: 1010;
}

/*.subview {
	transition: 0.4s transform ease;
}
.subview.underneath {
	transform: translateX(-80px);
}*/

main {

}
h2 {
	margin-left: 1rem;
	margin-right: 1rem;
}
h2:nth-of-type(2) {
	color: #999;
	font-weight: 500;
	margin-bottom: 4rem;
}
h3 {
	/*border-bottom: 1px solid #ccc;*/
	font-size: 19px;
	font-weight: 600;
	padding-bottom: 0.5rem; 
}

li {
	align-items: center;
	display: flex;
	height: 48px;
	justify-content: space-between;
}
li.major {
	height: 56px;
}


/*MODAL*/
/*.modalView--container {
	padding: 1rem;
}*/
.modalView--container h1 {
	font-size: 28px;
	margin-bottom: 1.5rem;
}
.modalView--container ul {
	margin-bottom: 3rem;
}
.modalView--container h1 span {
	color: #999;
	font-weight: 500;
}


/*ACTION BAR*/
.action_bar {
	justify-content: space-between;
}



/*SEARCH*/
.search {
	display: flex;
	left: 0;
	overflow-x: hidden;
	padding: 6px 1rem 6px;
	position: absolute;
	top: 10rem;
	transition: 0.4s top ease, 0.4s transform ease;
	width: calc(100% + 80px);
	z-index: 1020;
}
.search_input--clear {
	color: var(--blue);
	font-weight: 400;
	height: 36px;
	width: 80px;
	/*position: absolute;
	right: 1rem;
	top: 6px;*/
}
.search_input {
	appearance: none;
	background: #F1F1F2 url('/img/icon--search--input.svg') no-repeat 0.25rem center;
	border: none;
	border-radius: 8px;
	height: 36px;
	outline: none;
	padding-left: 2rem;
	padding-right: 0.75rem;
	transition: 0.4s width ease;
	width: calc(100% - 80px);
}
.search_input::placeholder {
	color: transparent;
	transition: color 0.3s ease;
}
.search_results {
	background-color: rgba(255,255,255,1);
	bottom: 0;
	left: 0;
	padding: 3rem 1rem 4rem;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 10;
}
.search.active {
	position: fixed;
	top: env(safe-area-inset-top);
	z-index: 1100;
}
.search.active .search_input {
	width: calc(100% - 80px - 48px - 1rem);
}
.search.active .search_input::placeholder {
	color: #bbb;
	transition: color 0.3s ease;
}

/*SEARCH TRANSITIONS*/
.search_results_fade-enter-active {
  transition: opacity 0.1s ease;
}
.search_results_fade-leave-active {
  transition: opacity 0.3s ease 0.3s;
}
.search_results_fade-enter, .search_results_fade-leave-to {
  opacity: 0;
}


/*PREVIOUSLY SEARCHED LIST*/
.previous_search_list {
	border-top: none;
	margin-top: 1rem;
}
.previous_search_list li {
	border-bottom: none;
	display: flex;
	height: auto;
	justify-content: space-between;
}
.previous_search_list button {
	color: #999;
	font-weight: 400;
	line-height: 1.25em;
	padding-bottom: 0.75rem;
	padding-top: 0.75rem;
	text-align: left;
}
.previous_search_list button:first-of-type {
	width: 100%;
}
.previous_search_list button .code {
	font-weight: 700;
}


/*PREVIOUSLY SEARCHED LIST TRANSITIONS*/
.previous_search_list_fade-enter-active {
  transition: opacity 0.3s ease 0.2s;
}
.previous_search_list_fade-leave-active {
  transition: opacity 0.1s ease;
}
.previous_search_list_fade-enter, .previous_search_list_fade-leave-to {
  opacity: 0;
}



/*SEARCH SUB-VIEW*/
/*.search,*/
.search_results {
	/*transition: 0.4s transform ease;*/
}
.search.underneath,
.search_results.underneath {
	/*transform: translateX(-80px);*/
}


/*PERSON ACTIONS*/
button.button--search_options {
	background: url('/img/tab_bar--create.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}


/*PATIENT SHEET*/
.patient_card h1 {
	margin-bottom: 0rem;
}
.patient_card h4 {
	color: #999;
	font-size: 17px;
	font-weight: 500;
	margin-bottom: 1rem;
	margin-top: 0.25rem;
}
.patient--groups {
	margin-bottom: 1.5rem;
}
.patient--groups--cell {
	background-color: #f5f5f5;
	border: 1px solid #ddd;
	border-radius: 4px;
	cursor: pointer;
	display: inline-block;
	font-size: 13px;
	font-weight: 600;
	margin-right: 0.5rem;
	padding: 0rem 0.5rem;
	text-transform: uppercase;
}
.patient--groups {

}
ul.patient--data {
	border-top: none;
	margin-bottom: 1rem;
}
.patient--data li {
	border-bottom: none;
	display: flex;
	justify-content: flex-start;
	padding-bottom: 0.5rem;
	padding-top: 0.5rem;
}
.patient--data li .patient--data--group:not(:last-of-type) {
	margin-right: 1rem;
}
.patient--data li .patient--data--group  .patient--data--group {
	color: #999;
	font-size: 13px;
	line-height: 1.25em;
	text-transform: uppercase;
}



/*SLIDEUP - ACTION SHEET*/
.pull {
	background-color: #ccc;
	border-radius: 3px;
	height: 6px;
	left: calc(50% - 1.5rem);
	margin-top: 0.25rem;
	position: absolute;
	top: 0;
	width: 3rem;
}
.slide_up--actions {
	border-top: none;
	margin-top: 1rem;
}
.slide_up--actions li {
	height: 48px;
	line-height: 48px;
}
.slide_up--actions li button {
	color: var(--blue);
	height: 48px;
}




/*STATUS : ACTIVITY*/
.nav--home {
	background-color: #fff;
	box-shadow: 0 6px 6px 0 #ddd;
	position: sticky;
	top: 0;
	z-index: 3;
}
.nav--home.search_active {
	position: static;
}
.nav--home button {
	font-size: 19px;
	font-weight: 600;
	height: 48px;
	margin-left: 1rem;
	margin-right: 1rem;
}
.nav--home button.active {
	border-bottom: 4px solid #007AFF;
}
.activity--count {
	background-color: var(--blue);
	border-radius: 2px;
	color: #fff;
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	height: 18px;
	line-height: 18px;
	padding-left: 0.25rem;
	padding-right: 0.25rem;
}



.home--wrapper.activityActive {
	transform: translateX(-50%);	
}
.status {
	background-color: #ddd;
	padding: 1rem 1rem calc(4rem + env(safe-area-inset-bottom));
}
.status--widget {
	background-color: #fff;
	border-radius: 4px;
	/*height: 200px;*/
	margin-bottom: 1rem;
	padding: 0.75rem;
	width: 100%;
}
.status--widget--title {
	border-bottom: 1px solid #ddd;
	display: flex;
	justify-content: space-between;
}
.status--widget.claims {
	height: auto;
}
.status--widget h3 {
	font-size: 17px;
}
.claims_status {
	display: flex;
	margin-left: -0.75rem;
	width: calc(100% + 1.5rem)
}
.claims_status--cell {
	margin-bottom: 1rem;
	margin-top: 1rem;
	text-align: center;
	width: calc(100% / 3);
}
.claims_status--cell--title {
	color: #999;
	font-size: 14px;
	font-weight: 600;
	margin-bottom: 0.5rem;
}
.claims_status--cell--count {
	font-size: 22px;
	font-weight: 600;
}
.claims_status--cell--dollars {
	margin-right: 0.25rem;
}
.claims_status--cell--dollars:before {
	color: #aaa;
	content: "$";
	display: inline-block;
	font-size: 13px;
	font-weight: 400;
	margin-right: 0.1rem;
	vertical-align: top;
}
.claims_status--cell--percentage {
	margin-left: 0.25rem;
}
.claims_status--cell--percentage:after {
	color: #aaa;
	content: "%";
	display: inline-block;
	font-size: 13px;
	font-weight: 400;
	margin-left: 0.1rem;
	vertical-align: top;
}
.claims_status--cell + .claims_status--cell {
	border-left: 0.5px solid #ccc;
}
.claims_status--issues {
	align-items: center;
	background-color: rgba(255,0,0,0.1);
	border-radius: 8px;
	display: flex;
	justify-content: center;
	height: 40px;
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}
.claims_status--issues--title {
	color: red;
	font-size: 17px;
	font-weight: 600;
}
.claims_status--issues--count {
	align-items: center;
	background-color: red;
	border-radius: 4px;
	color: #fff;
	display: flex;
	font-size: 20px;
	font-weight: 700;
	height: 1.75rem;
	justify-content: center;
	width: 1.75rem;
}
.status--widget.payment_timeline {
	height: auto;
	padding-bottom: 0;
}
.payment_timeline--timeline {
	margin-top: 1rem;
	padding-bottom: 0.5rem;
	position: relative;
}
.payment_timeline--timeline:before {
	background-color: #ccc;
	content: "";
	display: block;
	height: 90px;
	left: 11px;
	position: absolute;
	top: -1rem;
	width: 2px;
	z-index: 1;
}
.payment_timeline--timeline:after {
	border-left: 2px dashed #ccc;
	bottom: 0;
	content: "";
	display: block;
	height: 190px;
	left: 11px;
	position: absolute;
	width: 0px;
	z-index: 1;
}
.payment_timeline--timeline ul {
	border: none;
	position: relative;
	z-index: 2;
}
.payment_timeline--timeline ul li {
	align-items: flex-start;
	border: none;
	justify-content: flex-start;
	margin-bottom: 1rem;
}
.payment_timeline--timeline .check {
	background: url('/img/icon--check--empty.svg') no-repeat center center;
	height: 24px;
	margin-right: 0.5rem;
	width: 24px;
}
.payment_timeline--timeline .checked {
	background: url('/img/icon--check--selected.svg') no-repeat center center;
	background-size: 24px 24px;
	border: 4px solid #fff;
	border-radius: 16px;
	height: 32px;
	margin-left: -4px;
	margin-right: 0.5rem;
	width: 32px;
}
.payment_timeline--timeline .check--title {
	padding-top: 3px;
}
.check--title--date {
	font-weight: 600;
}
.check--title--event {
	color: #999;
	/*font-weight: 600;*/
}
.check--title--event span {
	font-weight: 400;
}


/*TRENDS CHART*/
.status--widget.trends {
	padding-bottom: 0;
}
.trends--chart {
	align-items: center;
	background-color: #f7f7f7;
	color: #ddd;
	display: flex;
	font-size: 64px;
	font-weight: 700;
	height: 150px;
	justify-content: center;
	margin-bottom: 0.5rem;
	margin-top: 0.5rem;
}
.trends--period_selector {
	/*background-color: pink;*/
	display: flex;
	margin-left: -0.75rem;
	width: calc(100% + 1.5rem);
}
.trends--period_selector button + button {
	border-left: 0.5px solid #ccc;
}
.period--1,
.period--2,
.period--3,
.period--4 {
	align-items: center;
	color: var(--blue);
	display: flex;
	flex-grow: 1;
	justify-content: center;
	height: 40px;
	/*width: calc(100% / 3);*/
}


/*STATISTICS*/
.statistics {
	padding-bottom: 0;
}
.statistics .claims_status--cell {
	width: 50%;
}
.statistics .claims_status--cell--title {
	margin-bottom: 0;
	margin-top: 0.5rem;
}


.activity {
	background-color: #ddd;
	min-height: 150vh;
	padding: 1rem 1rem 4rem;
	width: 100%;
}



.home > .action_bar {
	justify-content: flex-end;
}
.button--account {
	align-items: center;
	display: flex;
	color: #666;
	font-weight: 600;
	padding: 12px;
}
.button--account img {
	margin-left: 0.5rem;
}
.segmented_controller {
	align-items: center;
	background-color: #eee;
	border-radius: 4px;
	display: flex;
	height: 36px;
	
}
.button--controller {
	align-items: center;
	display: flex;
	font-size: 16px;
	font-weight: 600;
	height: 36px;
	justify-content: center;
	width: 56px;
}
.button--controller + .button--controller {
	margin-left: -0.5rem;
}
.button--controller.active {
	background-color: #007AFF;
	border-radius: 4px;
	color: #fff;
}
.button-refresh {
	height: 48px;
	width: 100%;
}


.list_item {
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	font-weight: 500;
	text-align: left;
	height: 48px;
	width: 100%;
}
.list_item--with_minor_text {
	height: 56px;
}
.list_item .minor {
	color: #aaa;
	font-size: 14px;
	font-weight: 400;
	margin-top: 0.125rem;
}
.list_item--security_pin {
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	justify-content: flex-start;
}
.list_item--security_pin .list_item{
	background: none;
	width: calc(100% - 70px - 24px);
}



/*ICONS*/
.account {
	background: url('/img/icon--account.svg') no-repeat center center;
}
.back {
  background: url('/img/icon--arrow--back.svg') no-repeat center center;
}
.icon--help {
  background: url('/img/icon--help.svg') no-repeat center center;
}



/*ACTIVITY ALERTS*/
.remittance_update {
	background-color: #fff;
	border-radius: 8px;
	font-size: 19px;
	font-weight: 500;
	line-height: 1.25rem;
	margin-bottom: 1rem;
	padding-bottom: 0.25rem;
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}
.remittance_update p {
	font-style: 15px;
	font-weight: 400;
	line-height: 1.375em;
	margin-bottom: 0.75rem;
}
.remittance_update--header {
	align-items: center;
	border-bottom: 1px solid #ccc;
	display: flex;
	font-weight: 600;
	height: 56px;
	justify-content: space-between;
	margin-bottom: 0.75rem;
}
.remittance_update--body {
	padding-bottom: 0.75rem;
}
.remittance_update--body ul {
	border: none;
	margin-left: 1.25rem;
}
.remittance_update--body ul li {
	border: none;
	display: list-item;
	font-weight: 400;
	height: auto;
	line-height: 1.375rem;
/*	padding-left: 1.25rem;*/
	list-style: square;
}
/*.remittance_update--body ul li:before {
	border-radius: 7px;
	content: "";
	display: inline-block;
	height: 14px;
	margin-left: -1.25rem;
	margin-right: 0.5rem;
	width: 14px;
}
.remittance_update--body ul li:nth-of-type(1):before {
	background-color: #00E28B;
}
.remittance_update--body ul li:nth-of-type(2):before {
	background-color: #FFE082;
}
.remittance_update--body ul li:nth-of-type(3):before {
	background-color: red;
}*/
.remittance_update--body ul li:not(:last-of-type) {
	margin-bottom: 1rem;
}
.remittance_update--body ul li span {
	font-weight: 700;
}

.remittance_update--cell {
	align-items: center;
	background: #FFE082 url('/img/icon--chevron--right.svg') no-repeat calc(100% - 0.25rem) center;
	border-radius: 8px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	height: 40px;
	margin-bottom: 0.5rem;
	padding-left: 0.75rem;
	padding-right: 2rem;
}
.remittance_update--cell h4 {
	color: #111;
}
.remittance_update--issues .remittance_update--cell {
	background-color: #FF3D00;
	color: rgba(255,255,255,1);
}
.remittance_update--issues .remittance_update--cell h4 {
	color: #fff;
}
.remittance_update--remittance_received {
	background-color: #00E28B;
	/*background-color: transparent;*/
}
.remittance_update--remittance_received .remittance_update--header {
	border: none;
	height: 48px;
	margin-bottom: 0;
}

.icon--check--success {
	background: url('/img/icon--success.svg') no-repeat center center;	
}


.alert {
	background-color: rgba(255,255,255,0.8);
	border-radius: 4px;
	cursor: pointer;
	margin-bottom: 1rem;
}
.alert--header {
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	border-bottom: 1px solid #ddd;
	margin-left: 0.75rem;
	margin-right: 0.75rem;
	padding: 0.75rem 0;
}
.alert--header--date {
	color: #999;
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 0.375rem;
}
.alert--header--name {
	font-size: 21px;
	font-weight: 600;
}
.alert--header--code {
	background-color: rgba(0,0,0,0.05);
	/*border: 1px solid rgba(0,0,0,0.2);*/
	border-radius: 2px;
	color: #999;
	display: inline-block;
	font-size: 14px;
	font-weight: 600;
	margin-right: 0.25rem;
	margin-top: 0.5rem;
	padding: 0.25rem;
}
.alert--details {
	padding: 0.75rem;
}
.alert--details--status {
	border-radius: 2px;
	color: #fff;
	display: inline-block;
	font-size: 13px;
	font-weight: 600;
	margin-bottom: 0.5rem;
	/*margin-top: 0.25rem;*/
	padding: 0.25rem 0.375rem;
	text-transform: uppercase;
}
.alert--details--status--open {
	background-color: #FF3B30;
}
/*.alert--details--status--open:before {
	background-color: #FF3B30;
	border-radius: 7px;
	content: "";
	display: inline-block;
	height: 14px;
	margin-bottom: -2px;
	margin-right: 0.25rem;
	width: 14px;
}*/
.alert--details--status--pending {
	background-color: #F5A623;
}
/*.alert--details--status--pending:before {
	background-color: #F5A623;
	border-radius: 7px;
	content: "";
	display: inline-block;
	height: 14px;
	margin-bottom: -2px;
	margin-right: 0.25rem;
	width: 14px;
}*/
.alert--details--explanation {
	line-height: 1.375em;
}



/*PATIENT NAV*/
.nav--claim {
	background-color: #fff;
	border-bottom: 1px solid #eee;
	/*box-shadow: 0 6px 6px 0 #ddd;*/
	margin-left: -1rem;
	position: sticky;
	top: 0;
	width: calc(100% + 2rem);
}
.nav--claim.search_active {
	position: static;
}
.nav--claim button {
	font-size: 17px;
	font-weight: 600;
	height: 48px;
	margin-left: 1rem;
	margin-right: 1rem;
}
.nav--claim button.active {
	border-bottom: 4px solid #007AFF;
}


/*PATIENT CARD*/
.patient_tab--1 {

}
.patient_tab--2 {
	
}
.patient--action_bar {
	align-items: center;
	background-color: rgba(255,255,255,0.9);
	/*border-radius: 8px;*/
	border-top: 1px solid #eee;
	bottom: calc(48px + env(safe-area-inset-bottom));
	display: flex;
	height: 56px;
	justify-content: center;
	left: 0;
	position: fixed;
	width: 100%;
}
.patient--action_bar button {
	border-radius: 8px;
	font-size: 16px;
	height: 36px;
	margin-left: 0.5rem;
	margin-right: 0.5rem;
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}


.sign_up {
	background-color: #fff;
	border-radius: 4px;
	font-size: 19px;
	margin-bottom: 1rem;
}
.sign_up--details {
	padding-bottom: 1rem;
	padding-top: 0.25rem;
	position: relative;
}
.sign_up--details .check {
	background: url('/img/icon--check--empty.svg') no-repeat center center;
	border: 2px solid #fff;
	border-radius: 14px;
	height: 28px;
	margin-right: 0.5rem;
	width: 28px;
}
.sign_up--details .checked {
	background: url('/img/icon--check--selected.svg') no-repeat center center;
}
.sign_up--details .flag {
	background: #fff url('/img/icon--flag.svg') no-repeat center center;
}
.sign_up--details.in_progress:before {
	background-color: #ddd;
	bottom: 2rem;
	content: "";
	display: block;
	left: 21.5px;
	position: absolute;
	top: 1rem;
	width: 1px;
	z-index: 1;
}
.sign_up--details ul {
	border: none;
	position: relative;
	z-index: 2;
}
.sign_up--details ul li {
	border: none;
	display: flex;
	font-size: 15px;
	height: 40px;
	justify-content: flex-start;
	padding-left: 0.5rem;
}
.sign_up--header {
	border-bottom: 1px solid #ddd;
	font-weight: 600;
	padding: 1rem;
}

.sign_up--details.complete {
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.sign_up--details.complete .check {
	background-size: 64px 64px;
	height: 96px;
	width: 96px;
}

</style>
